<script setup lang="ts">
const { siteName = '' } = useRuntimeConfig().public

useHead({
  htmlAttrs: {
    lang: 'en',
  },
})
useSeoMeta({
  title: siteName,
  titleTemplate: (s) => {
    if (s && s !== siteName) {
      return `${s} | ${siteName}`
    }
    return siteName
  },
})
const env = useRuntimeConfig().public.siteEnv
function clearCache() {
  clearNuxtData()
}
</script>

<template>
  <div class="bg-slate-100 min-h-screen  flex flex-col relative">
    <NavigationMain />
    <NuxtLayout>
      <NuxtPage class="relative z-10" />
    </NuxtLayout>
    <!-- <button
      v-if="env === 'development'"
      class="fixed bottom-0 right-0 p-2 bg-red-500 text-white z-50 flex items-center justify-center"
      @click="clearCache"
    >
      <Icon name="heroicons:arrow-path" />
    </button> -->
    <UNotifications>
      <template #description="{ description }">
        <span v-html="description" />
      </template>
    </UNotifications>
    <LazyIdleGlobalModal hydrate-on-idle />
  </div>
</template>
